import { Component, Input, ContentChildren, ViewEncapsulation, forwardRef, OnDestroy } from '@angular/core';

import { ExpandableComponent } from '../expandable/expandable.component';
import { IdService } from '../../shared/services/id.service';

@Component({
	selector: 'rbc-expandable-container',
	templateUrl: './expandable-container.component.html',
	encapsulation: ViewEncapsulation.None,
	styleUrls: ['./expandable-container.component.scss']
})
export class ExpandableContainerComponent implements OnDestroy {
	// Private Members
	id: string;

	// Input Parameters
	@Input() accordion: boolean = false;
	@Input() card: boolean = true;
	@Input() header: string;
	@Input() showButton = true;
	@Input() buttonOpenAll: string = 'Expand all';
	@Input() buttonCloseAll: string = 'Collapse all';

	@ContentChildren(forwardRef(() => ExpandableComponent)) expandables;

	constructor(private idService: IdService) {
		this.id = idService.generate();
	}

	ngOnDestroy(): void {
		this.idService.remove(this.id);
	}

	buttonText() {
		return this.isAllExpanded() ? this.buttonCloseAll : this.buttonOpenAll;
	}

	toggleExpanded() {
		const action = !this.isAllExpanded();

		for (const expandable of this.expandables._results) {
			expandable.expanded = action;
		}
	}

	isAllExpanded() {
		for (const expandable of this.expandables._results) {
			if (!expandable.expanded) {
				return false;
			}
		}

		return true;
	}

	childExpanded(id: string, expanded: boolean) {
		if (!this.accordion) {
			return;
		}

		for (const expandable of this.expandables._results) {
			if (expandable.id !== id) {
				expandable.expanded = !expanded;
			}
		}
	}
}
